// extracted by mini-css-extract-plugin
module.exports = {"text_primary":"ColoredSentence_text_primary__1_PqN","text_black":"ColoredSentence_text_black__ro1O2"};